import request from '@/axios/designManager'
import eRequest from '@/axios/eContract'
import post from '@/axios/upload'

// 01-获取门店列表
export function getStoreList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/staff/staff_store/getStoreList',
    method: 'post',
    data
  })
}

// 02-获取员工详情
export function getStaffDetail(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/staff/staff/getStaffDetail',
    method: 'post',
    data
  })
}

// 03-切换当前门店
export function changeStore(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/staff/staff_store/changeStore',
    method: 'post',
    data
  })
}

// 12-获取小区
export function getVillageList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getVillageList',
    method: 'post',
    data
  })
}

// d-01-获取设计师服务数据计数
export function getDesignerBusinessCount(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/designer/getDesignerBusinessCount',
    method: 'post',
    data
  })
}
// A-04-设计师业务及时处理率
export function getOperationDispose(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/analysis/getOperationDispose',
    method: 'post',
    data
  })
}
// A-05-设计师综合数据分析
export function getAnalysisSynthesis(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/analysis/getAnalysisSynthesis',
    method: 'post',
    data
  })
}
// A-06-设计师个人合同额趋势图
export function getContractAmountChart(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/analysis/getContractAmountChart',
    method: 'post',
    data
  })
}
// A-07-设计师个人转化率趋势图
export function getPercentConversionChart(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/analysis/getPercentConversionChart',
    method: 'post',
    data
  })
}
// G-02-硬装流程订单列表
export function getProcessOrderList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order/getProcessOrderList',
    method: 'post',
    data
  })
}
// 待合同签约
export function getContractList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/designer/getContractList',
    method: 'post',
    data
  })
}
// 收款
export function getOrderList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/designer/getOrderList',
    method: 'post',
    data
  })
}
// 退单
export function getAllList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order/getAllList',
    method: 'post',
    data
  })
}
// d-03-手机号/姓名搜索订单
export function getCustomers(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/designer/getCustomers',
    method: 'post',
    data
  })
}
// 0501-手机号获取订单状态
export function getOrderStatus(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_refund_amount/getOrderStatus',
    method: 'post',
    data
  })
}
// 05-获取订单列表
export function getOrderRefundList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_refund_amount/getOrderList',
    method: 'post',
    data
  })
}

// S-01-获取消息列表
export function getMessageList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/message/getMessageList',
    method: 'post',
    data
  })
}
// 01-添加退款单(新)
export function saveRefundAmount(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_refund_amount/saveRefundAmount',
    method: 'post',
    data
  })
}

export function getRefundLabelList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_refund_amount/getRefundLabelList',
    method: 'post',
    data
  })
}

// S-03-读取消息
export function readMessageInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/message/readMessageInfo',
    method: 'post',
    data
  })
}

// S-05-更新消息为已读状态
export function updateMessageStatus(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/message/updateMessageStatus',
    method: 'post',
    data
  })
}
export function getChangeItems(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order/getChangeItems',
    method: 'post',
    data
  })
}
// 添加勘测邀请函
export function saveMeasureInvite(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/measure/measure/saveMeasureInvite',
    method: 'post',
    data
  })
}
// 获取勘测邀请函
export function getMeasureInvite(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/measure/measure/getMeasureInvite',
    method: 'post',
    data
  })
}
// 获取群客户信息
export function getFlockproPrietorInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/measure/measure/getFlockproPrietorInfo',
    method: 'post',
    data
  })
}
// G-05-待勘测订单详情
export function getMetering(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/no_signed/getMetering',
    method: 'post',
    data
  })
}

// 订单套餐列表
export function getStoreProductPackage(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/product_package/getStoreProductPackage',
    method: 'post',
    data
  })
}

// 获取报价订单-基础产品包详情
export function getOfferBasics(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/offer/offer_basics/getOfferBasics',
    method: 'post',
    data
  })
}

// 获取订单相关基础信息
export function getOrderInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/offer/offer/getOrderInfo',
    method: 'post',
    data
  })
}

// 基础报价提交
export function saveOfferBasics(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/offer/offer_basics/saveOfferBasics',
    method: 'post',
    data
  })
}

// 精简版报价-02-精简版报价单详情
export function getOfferDetails(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/offer/offer_subject/getOfferDetails',
    method: 'post',
    data
  })
}

// 0201-添加勘测邀请函
export function saveNewMeasureInvite(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/measure/measure/saveNewMeasureInvite',
    method: 'post',
    data
  })
}
// 获取小区
export function getVillage(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getVillageList',
    method: 'post',
    data
  })
}

// 创建合同提交
export function saveContract(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_contract/saveContract',
    method: 'post',
    data
  })
}

// 获取合同签约详情
export function getContract(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_contract/getContract',
    method: 'post',
    data
  })
}

// G-0501-待勘测订单提交
export function saveMetering(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/no_signed/saveMetering',
    method: 'post',
    data
  })
}

// 临时01-报价提交
export function saveOffer(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/offer/offer_subject/saveOffer',
    method: 'post',
    data
  })
}

// 获取实名认证地址
export function authent(data) {
  return eRequest({
    url: process.env.VUE_APP_BASE_API_ECONTRACT + '/user/user/authent',
    method: 'post',
    data
  })
}

// 获取门店包列表
export function buildCode(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/tools/buildCode',
    method: 'post',
    data
  })
}
// 获取上传图片Token
export function getUploadToken(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/tools/getUploadToken',
    method: 'post',
    data
  })
}

// 用支付序号查询支付信息
export function getOrderAmountInfoById(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_amount/getOrderAmountInfoById',
    method: 'post',
    data
  })
}

// 发送付款码
export function sendAmountImage(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_amount/sendAmountImage',
    method: 'post',
    data
  })
}
// 获取权限列表
export function upLoadImage(file, data) {
  const param = new FormData()
  param.append('file', file)
  if (data) {
    Object.keys(data).forEach(element => {
      param.append(element, data[element])
    })
  }
  return post({
    url: '//upload.qiniup.com',
    method: 'post',
    data: param,
    config: {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
  })
}

// G-06-待设计订单提交
export function saveDesign(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/no_signed/saveDesign',
    method: 'post',
    data
  })
}

// 报价单收款
export function receiptAmount(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/offer/offer_receipt/receiptAmount',
    method: 'post',
    data
  })
}
// A-在线交付-03-获取客户详情
export function getConfideInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_inspection/sidebar/confide/getConfideInfo',
    method: 'post',
    data
  })
}

// G-07 收首款详情
export function getAmount(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_amount/getAmount',
    method: 'post',
    data
  })
}

// 用户信息
export function getUserInfo(data) {
  return eRequest({
    url: process.env.VUE_APP_BASE_API_ECONTRACT + '/user/user/get_user_info',
    method: 'post',
    data
  })
}

// 合同预览页接口
export function contract(data) {
  return eRequest({
    url: process.env.VUE_APP_BASE_API_ECONTRACT + '/contract/contract/index',
    method: 'post',
    data
  })
}

// 撤销合同
export function voidContract(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_contract/voidContract',
    method: 'post',
    data
  })
}

// G-1108-发送电子合同到企业微信控制台
export function sendContractDing(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_contract/sendContractDing',
    method: 'post',
    data
  })
}

// G-0802-获取合同详情
export function getContractInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_contract/getContractInfo',
    method: 'post',
    data
  })
}

// G-0803-添加合同资源
export function saveOrderContractResource(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_contract/saveOrderContractResource',
    method: 'post',
    data
  })
}

// 发送电子邮件
export function sendEmail(data) {
  return eRequest({
    url: process.env.VUE_APP_BASE_API_ECONTRACT + '/contract/contract/send_email',
    method: 'post',
    data
  })
}

// G-1302-创建交底邀请函
export function saveConfide(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/confide/saveConfide',
    method: 'post',
    data
  })
}
// 设计师播报
export function getBroadcastDesigner(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/analysis/getBroadcastDesigner',
    method: 'post',
    data
  })
}

// 设计师播报
export function getDiscloseInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_inspection/applets/disclose/getDiscloseInfo',
    method: 'post',
    data
  })
}

// (rad1)-02-提交评测
export function getRadList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/rad_three/getRadList',
    method: 'post',
    data
  })
}

// D-02-初步需求档案列表
export function getDemandedList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/designer/getDemandedList',
    method: 'post',
    data
  })
}

// M-获取本次应收金额
export function getReceivableAmount(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_amount/getReceivableAmount',
    method: 'post',
    data
  })
}
// G-1101-cad文件上传状态
export function getCadStatus(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/no_disclose/getCadStatus',
    method: 'post',
    data
  })
}
// G-11-提交工程部
export function saveEngineering(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/no_disclose/saveEngineering',
    method: 'post',
    data
  })
}
// B-14-获取服务岗位员工列表
export function getStationStaffList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getStationStaffList',
    method: 'post',
    data
  })
}
// CM-02-用户档案
export function customerInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/manager/customerInfo',
    method: 'post',
    data
  })
}
// 27-设计服务空间列表
export function getSpaceList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getSpaceList',
    method: 'post',
    data
  })
}
// CM-04-获取成员
export function getMembers(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/manager/getMembers',
    method: 'post',
    data
  })
}
// 04-获取选项字段选择下拉列表
export function getSelectFieldOption(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getSelectFieldOption',
    method: 'post',
    data
  })
}

// 09-获取房屋类型
export function getHouseTypeList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getHouseTypeList',
    method: 'post',
    data
  })
}
// 29-获取性格倾向
export function getCharacterTrend(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getCharacterTrend',
    method: 'post',
    data
  })
}

// H-23-整装报价提交
export function saveWholeOffer(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/offer/offer_subject/saveWholeOffer',
    method: 'post',
    data
  })
}
// 18-获取线下渠道列表
export function getOfflineChannel(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getOfflineChannel',
    method: 'post',
    data
  })
}
// 10-获取房屋状态类型
export function getHouseStatusList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getHouseStatusList',
    method: 'post',
    data
  })
}

// 27-获取产品包基础项价格
export function getProductPackageBaseItemPrice(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/product_package/getProductPackageBaseItemPrice',
    method: 'post',
    data
  })
}

// 带报价订单列表
export function getOfferList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/offer/offer/getOfferList',
    method: 'post',
    data
  })
}

// 设计师分享服务手册
export function addShareRecord(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/designer/addShareRecord',
    method: 'post',
    data
  })
}

// B-01-获取订单节点流程列表
export function getProcessList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/v2/order/getProcessList',
    method: 'post',
    data
  })
}

// B-02-流程订单列表
export function getProcessOrderListV2(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/v2/order/getProcessOrderList',
    method: 'post',
    data
  })
}

// H-22-获取已确定报价列表
export function getConfirmOfferList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/offer/offer/getConfirmOfferList',
    method: 'post',
    data
  })
}

// 选材主页-选材确认提交
export function getMySelectionList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/selection/selection_subject/getMySelectionList',
    method: 'post',
    data
  })
}

// 16-预上门客户未到店
export function getOrderAmountList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_amount/getOrderAmountList',
    method: 'post',
    data
  })
}

// 选材主页-获取材料分类
export function getMaterialsCategory(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/selection/selection/getMaterialsCategory',
    method: 'post',
    data
  })
}

// M-获取收款单详情
export function closeAmount(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_amount/closeAmount',
    method: 'post',
    data
  })
}

export function getOrderAmountId(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_amount/getOrderAmountInfo',
    method: 'post',
    data
  })
}
// G-9001-订单详情-基本信息
export function getBaseOrderDetail(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_detail/getBaseOrderDetail',
    method: 'post',
    data
  })
}

// 选材单主页
export function getSubject(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/selection/selection_subject/getSubject',
    method: 'post',
    data
  })
}

// 28-发送验证码
export function sendSmsCode(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/tools/sendSmsCode',
    method: 'post',
    data
  })
}

// 03-获取退款单详情
export function getRefundAmountInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_refund_amount/getRefundAmountInfo',
    method: 'post',
    data
  })
}

// 2-发起审批
export function saveApprovalInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/approval/refund_amount_approval/saveApprovalInfo',
    method: 'post',
    data
  })
}
// 选材主页-获取分类材料列表
export function getMaterialsList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/selection/selection/getMaterialsList',
    method: 'post',
    data
  })
}

// 选材主页-材料详情
export function getMaterials(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/selection/selection/getMaterials',
    method: 'post',
    data
  })
}

// 选材主页-选材提交
export function saveSelection(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/selection/selection/saveSelection',
    method: 'post',
    data
  })
}

// 选材预览-空间分类
export function getPreviewCategory(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/selection/selection_subject/getPreviewCategory',
    method: 'post',
    data
  })
}

// 选材预览-分类选材明细
export function getPreviewList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/selection/selection_subject/getPreviewList',
    method: 'post',
    data
  })
}

// 选材预览-删除SKU
export function delEntity(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/selection/selection_subject/delEntity',
    method: 'post',
    data
  })
}

// 选材主页-选材确认提交
export function saveConfirmSelection(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/selection/selection_subject/saveConfirmSelection',
    method: 'post',
    data
  })
}

// 重置选材状态
export function resetSelection(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/selection/selection/resetSelection',
    method: 'post',
    data
  })
}
// 添加收款凭证
export function saveOrderAmountResource(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_amount/saveOrderAmountResource',
    method: 'post',
    data
  })
}
// 订单输单详情
export function getOrderLoseDetails(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order/getOrderLoseDetails',
    method: 'post',
    data
  })
}
// 输单提交
export function saveInvalid(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_change/saveInvalid',
    method: 'post',
    data
  })
}

// 01-待接收用户
export function getCustomerList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/manager/getCustomerList',
    method: 'post',
    data
  })
}

// (new)01-设计师修改勘测时间
export function editMeasure(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/v2/designer/editMeasure',
    method: 'post',
    data
  })
}

// 确认勘测
export function survey(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/design_process/survey',
    method: 'post',
    data
  })
}

// 提案邀约
export function saveFollow(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/follow/saveFollow',
    method: 'post',
    data
  })
}

// 修改提案邀约
export function updateSignTime(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/follow/updateSignTime',
    method: 'post',
    data
  })
}

export function saveProposalFollow(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/follow/saveProposalFollow',
    method: 'post',
    data
  })
}

export function updatePlanDisclose(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/no_disclose/updatePlanDisclose',
    method: 'post',
    data
  })
}

export function operateGetFields(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/customer/operate/getFields',
    method: 'post',
    data
  })
}

// 获取输单选项问题(3626)
export function getOrderLoseOptionQuestion(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_change/getOrderLoseOptionQuestion',
    method: 'post',
    data
  })
}
